
import { PropType, defineComponent } from 'vue';
import { AvailableLoan } from '@/interfaces/loan';
import CollectionAgencyContact from '@/components/Loans/Collections/CollectionAgencyContact.vue';
import applicationId from '@/filters/application-id';
import CustomButton from '~/components/Buttons/CustomButton.vue';

export default defineComponent({
  name: 'LoanInCollectionDialog',

  components: { CollectionAgencyContact, CustomButton },

  props: {
    loan: { type: Object as PropType<AvailableLoan>, required: true },
  },

  computed: {
    humanLoanNumber(): string {
      return applicationId(this.loan.loan_number);
    },

    hasCollectionAgencyInfo() : boolean {
      return this.loan.collection.collections_agency !== null;
    }
  }
});
